import { Component, OnInit, Output } from '@angular/core';
import * as $ from 'jquery';
import { UsersService } from 'src/app/services/users.service';
import { Router } from '@angular/router';
import { EventEmitter } from 'protractor';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.css']
})
export class LoginPageComponent implements OnInit {

  showForms:boolean = true  ; 
  name:string 
 showNavbar : boolean = false ; 
 userName:string 
  constructor(private Allusers:UsersService , private router:Router)
   {
    if(this.Allusers.currentUser >0)
    {
      this.showForms = false 
      for(let user of this.Allusers.users)
      {
        if(user.id === this.Allusers.currentUser)
        {
          this.name = user.firstName +" "+ user.lastName  ;
          break 
        }
      }
    }
   }

  ngOnInit() {

    
  }
  logout()
  {
    this.Allusers.currentUser = 0 ;
    this.showForms = false ;
    this.showNavbar = false ;
    this.Allusers.showNavbar = false ;
    this.Allusers.userName = " " 
    this.router.navigate(["/home"])
    
  }
  changeNavbarView()
  {
    this.showNavbar = true 
    for(let user of this.Allusers.users)
    {
      if(user.id == this.Allusers.currentUser)
      {
        this.userName = user.firstName + " " + user.lastName  
        this.Allusers.userName = this.userName 
        break ;
      }
    }
    
  }
  gotopro()
  {
    if(this.Allusers.currentUser>0)
    {
      this.showForms = false  ;
      for(let user of this.Allusers.users)
      {
        if(user.id === this.Allusers.currentUser)
        {
          this.name = user.firstName +" "+ user.lastName  ;
          break 
        }
      }
     
    }
  }
  

}
